/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-13 18:18:07
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-14 11:19:54
 * @FilePath: /unifyxp-v2-store-portal/src/components/DeleteInput/index.tsx
 */
import React from 'react';

import css from './css.module.less';

import { NumberInput } from 'src/components/Antd';
import { Icon } from '@/src/tools/icon';

const DeleteInput = (props) => {
  const { inputProps = {}, value, onChange, onDelete, disabled } = props;
  return (
    <div className={css.container}>
      <div className={css.inputContainer}>
        <NumberInput
          min={0}
          size='large'
          value={value}
          onChange={onChange}
          disabled={disabled}
          {...inputProps}
        />
      </div>
      {onDelete && !disabled ? (
        <Icon type='icondelete1' className={css.icon} onClick={onDelete} />
      ) : (
        <div className={css.iconPlaceholder} />
      )}
    </div>
  );
};
export default DeleteInput;
